import { LoanStatus, LoanStatusExternal } from '@nemuru-eng/js-api-client';

import { Milestone } from '@/components/modules/Funnel/types/Milestone';
import { ApplicationProgressStage } from '@/components/shared/components/Progress/types/applicationProgressStage';

export const ORDER_PROGRESS_STAGES: ApplicationProgressStage = {
  [Milestone.INITIAL]: [
    {
      nameTextId: Milestone.INITIAL,
      status: LoanStatusExternal.INITIAL,
      isMainStep: true,
      checkpointGroup: 1,
    },
    {
      nameTextId: 'PERSONAL_INFORMATION',
      status: LoanStatus.STATUS_ANALYSING,
      isMainStep: false,
      checkpointGroup: 1,
    },
  ],
  [Milestone.REQUESTED]: [
    {
      nameTextId: Milestone.REQUESTED,
      status: LoanStatusExternal.REQUESTED,
      isMainStep: true,
      checkpointGroup: 2,
    },
  ],
  [Milestone.APPROVED]: [
    {
      nameTextId: Milestone.APPROVED,
      status: LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED,
      isMainStep: true,
      checkpointGroup: 3,
    },
    {
      nameTextId: 'SMS_CODE',
      status: LoanStatus.STATUS_CONTRACT_SENT,
      isMainStep: false,
      checkpointGroup: 3,
    },
    {
      nameTextId: 'FIRST_INSTALMENT',
      status: LoanStatus.STATUS_CONTRACT_SIGNED,
      isMainStep: false,
      checkpointGroup: 3,
    },
  ],
  [Milestone.CONFIRMED]: [
    {
      nameTextId: Milestone.CONFIRMED,
      status: LoanStatusExternal.CONFIRMED,
      isMainStep: true,
      checkpointGroup: 2,
    },
    {
      nameTextId: 'CAPTURED',
      status: LoanStatusExternal.CAPTURED,
      isMainStep: false,
      checkpointGroup: 3,
    },
  ],
  [Milestone.PAID]: [
    {
      nameTextId: Milestone.PAID,
      status: LoanStatusExternal.PAID,
      isMainStep: true,
      checkpointGroup: 4,
    },
  ],
};
